<template>
    <div id="safaApp" class="root container-fluid">
        <div class="row content">
            <div class="stepper-nav col-12">
                <div class="wrapper-progressBar">
                    <ul class="progressBar">
                        <li :class="{ 'active' : currentStep >= 1, 'completed' : currentStep > 1 }" v-on:click="goToStep(1)" >Dades Familiars</li>
                        <li :class="{ 'active' : currentStep >= 2, 'completed' : currentStep > 2 }" v-on:click="goToStep(2)" >Dades Alumnes</li>
                        <li :class="{ 'active' : currentStep >= 3, 'completed' : currentStep > 3 }" v-on:click="goToStep(3)" >Escull Activitat</li>
                        <li :class="{ 'active' : currentStep >= 4, 'completed' : currentStep > 4 }" v-on:click="goToStep(4)" >Resum i Reserva</li>
                    </ul>
                </div>
            </div>

            <section class="step step-1 parents col-12" v-if="currentStep == 1">
                <div class="alert alert-info">
                    <strong v-on:click="makeParent()">Primer pas: </strong>Completa les dades del tutor que fa la inscripció. <strong>Si voleu afegir les dades de l’altre tutor clikeu <button type="button" class="btn btn-default btn-circle btn-add" disabled><i class="fas fa-plus"></i></button> per afegir-les.</strong>
                </div>
                <div class="alert alert-danger errors" style="display:none;"></div>
                <br>
                <div class="parents">
                    <div class="student-parents-info" v-for="(parent, indexParent) in parents" :key="indexParent">
                        <div :id="`parent-${indexParent}`">
                            <div class="parent-navigation">
                                <div class="row">
                                    <div class="col-md-8 d-flex justify-content-start">
                                        <h4>Tutor {{indexParent + 1}}</h4>
                                    </div> 
                                    <div class="col-md-4 d-flex justify-content-end">
                                        <button type="button" class="btn btn-default btn-circle btn-add" v-if="indexParent == parents.length - 1" @click="addParent(student)">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                        <button type="button" class="btn btn-default btn-circle btn-remove" v-if="indexParent > 0" @click="removeParent(parent, indexParent)">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="parent-section">
                                <div class="form-row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="parentName">Nom</label>
                                            <input class="form-control form-control-sm" type="text" :name="`parent[${indexParent}]parentName`" v-model="parent.parentName">
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="parentFirstName">Primer Cognom</label>
                                            <input class="form-control form-control-sm" type="text" :name="`parent[${indexParent}]parentFirstName`" v-model="parent.parentFirstName">
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="parentLastName">Segon Cognom</label>
                                            <input class="form-control form-control-sm" type="text" :name="`parent[${indexParent}]parentLastName`" v-model="parent.parentLastName">
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="parentVat">DNI</label>
                                            <input class="form-control form-control-sm" type="text" :name="`parent[${indexParent}]parentVat`" v-model="parent.parentVat" @change="e => parent.parentVat = e.target.value.trim()">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="parentPhone1">Telèfon 1</label>
                                            <input class="form-control form-control-sm" type="text" :name="`parent[${indexParent}]parentPhone1`" v-model="parent.parentPhone1">
                                        </div>
                                    </div>   
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="parentPhone2">Telèfon 2</label>
                                            <input class="form-control form-control-sm" type="text" :name="`parent[${indexParent}]parentPhone2`" v-model="parent.parentPhone2">
                                        </div>
                                    </div>      
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="parentEmail">Email</label>
                                            <input class="form-control form-control-sm" type="text" :name="`parent[${indexParent}]parentEmail`" v-model="parent.parentEmail">
                                        </div>
                                    </div>      
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="parentType">Relació</label>
                                            <select v-model="parent.parentType" class="form-control form-control-sm" :name="`parent[${indexParent}]parentType`">
                                                <option v-for="option in parentsOptions" :key="`${indexParent}_${option.value}`" :value="option.value">
                                                    {{ option.text }}
                                                </option>
                                            </select> 
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-md-4">
                                        <div class="form-group">                        
                                            <label class="font-weight-bold" for="parentAddress">Adreça</label>
                                            <input class="form-control form-control-sm" type="text" :name="`parent[${indexParent}]parentAddress`"  v-model="parent.parentAddress">
                                        </div>
                                    </div>
                                    <div class="col-md-1">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="parentAddressNumber">Nº</label>
                                            <input class="form-control form-control-sm" type="text" :name="`parent[${indexParent}]parentAddressNumber`" v-model="parent.parentAddressNumber">
                                        </div>
                                    </div>
                                    <div class="col-md-1">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="parentAddressFloor">Pis</label>
                                            <input class="form-control form-control-sm" type="text" :name="`parent[${indexParent}]parentAddressFloor`" v-model="parent.parentAddressFloor">
                                        </div>
                                    </div>
                                    <div class="col-md-1">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="parentAddressDoor">Porta</label>
                                            <input class="form-control form-control-sm" type="text" :name="`parent[${indexParent}]parentAddressDoor`" v-model="parent.parentAddressDoor">
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="parentAddressZip">Codi Postal</label>
                                            <input class="form-control form-control-sm" type="number" :name="`parent[${indexParent}]parentAddressZip`" v-model="parent.parentAddressZip">
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="parentAddressCity">Població</label>
                                            <input class="form-control form-control-sm" type="text" :name="`parent[${indexParent}]parentAddressCity`" v-model="parent.parentAddressCity">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br><hr><br>
                        <div class="add-parent-section">
                            <div class="row">
                                <div class="col-md-12 d-flex justify-content-end">
                                    <button type="button" class="btn btn-default btn-circle btn-add" v-if="indexParent == parents.length - 1 && parents.length < 2" @click="addParent()">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                    <button type="button" class="btn btn-default btn-circle btn-remove" v-if="indexParent > 0" @click="removeParent(parent, indexParent)">
                                        <i class="fas fa-minus"></i>
                                    </button>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
            </section>

            <section class="step step-2 student col-12" v-if="currentStep == 2">
                <div class="alert alert-info">
                	<strong v-on:click="makeStudent()">Segon pas: </strong>Completa les dades del primer alumne, <strong><span style="color: red;">a l'acabar pressiona sobre el botó <button type="button" class="btn btn-default btn-circle btn-add" disabled><i class="fas fa-plus"></i></button> per afegir un altre alumne.</span></strong>
                </div>
                <div class="alert alert-danger errors" style="display:none;"></div>                
                <br>
                <div class="student-section">
                    <div class="student-info-section" v-for="(student, index) in students" :key="index">
                        <div :id="`student-${index}`">
                            <div class="student-navigation">
                                <div class="row">
                                    <div class="col-md-8 d-flex justify-content-start">
                                        <h2>ALUMNE {{index + 1}}</h2>
                                    </div>
                                    <div class="col-md-4 d-flex justify-content-end">
                                        <button type="button" class="btn btn-default btn-circle btn-add" v-if="index == students.length - 1" @click="addStudent()">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                        <button type="button" class="btn btn-default btn-circle btn-remove" v-if="index > 0" @click="removeStudent(student, index)">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div class="student-contact-info">
                                <div class="form-row">
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="name">Nom</label>
                                            <input class="form-control form-control-sm" type="text" :name="`student[${index}]name`" v-model="student.name">
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="firstName">Primer Cognom</label>
                                            <input class="form-control form-control-sm" type="text" :name="`student[${index}]firstName`" v-model="student.firstName">
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="lastName">Segon Cognom</label>
                                            <input class="form-control form-control-sm" type="text" :name="`student[${index}]lastName`"  v-model="student.lastName">
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="vat">DNI</label>
                                            <input class="form-control form-control-sm" type="text" :name="`student[${index}]vat`"  v-model="student.vat">
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">                 
                                            <label class="font-weight-bold" for="date">Data de Naixement</label>
                                            <input class="form-control form-control-sm" type="date" :name="`student[${index}]date`" v-model="student.date" @change="$set(student, 'schoolCourse', null);">
                                        </div>
                                    </div>
                                    <!-- 
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="lastYear">Va assistir l'any anterior</label>
                                            <select class="form-control form-control-sm" :name="`student[${index}]lastYear`" v-model="student.lastYear" >
                                                <option v-for="option in trueFalseOptions" :key="option.value" :value="option.value">
                                                    {{ option.text }}
                                                </option>
                                            </select>                                          
                                        </div>               
                                    </div>
                                    -->
                                </div>
                                <div class="form-row">
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="local">Alumne SAFA</label>
                                            <select class="form-control form-control-sm" :name="`student[${index}]local`" v-model="student.local" @change="e => onLocalChange(index, e.target.value)">
                                                <option v-for="option in trueFalseOptions" :key="`${index}_${option.value}`" :value="option.value">
                                                    {{ option.text }}
                                                </option>
                                            </select> 
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="school">Escola</label>
                                            <input class="form-control form-control-sm" type="text" :name="`student[${index}]school`" v-model="student.school" :disabled="!!student.local">
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">                    
                                            <!-- TODO: Contenido de casal de SETEMBRE -->
                                            <label class="font-weight-bold" for="schoolCourse" v-if="casalId == 403">Curs escolar al 2026-2027</label>
                                            <!-- TODO: Contenido de casal de SETEMBRE -->
                                            <label class="font-weight-bold" for="schoolCourse" v-if="casalId == 422 || casalId == 0">Curs escolar</label>
                                            <select class="form-control form-control-sm" :name="`student[${index}]schoolCourse`" v-model="student.schoolCourse" @change="e => onSchoolCourseChange(index, e.target.value)">
                                                <option v-for="option in course" v-bind:key="`${index}_${option.value}`" :value="option.value">
                                                    {{ option.text }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="leaveAlone">Pot marxar sol/a</label>
                                            <select class="form-control form-control-sm" :name="`student[${index}]leaveAlone`" v-model="student.leaveAlone">
                                                <option v-for="option in trueFalseOptions" :key="`${index}_${option.value}`" :value="option.value">
                                                    {{ option.text }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />                        
                            <div class="student-relatives" v-if="student.leaveAlone == false">
                                <h3>DADES DE LES PERSONES AUTORITZADES A RECOLLIR EL NEN O NENA</h3>
                                <div class="student-default-relatives-info" v-for="(parent, indexParent) in parents" :key="indexParent">
                                    <div class="form-row">
                                        <div class="col-md-6">
                                            <div class="form-group">                
                                                <label class="font-weight-bold" for="relativeName">Nom</label>
                                                <input class="form-control form-control-sm" :value="parent.parentName + ' ' + parent.parentFirstName + ' ' + parent.parentLastName" disabled>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="font-weight-bold" for="relativeType">Relació</label>
                                                <input class="form-control form-control-sm" :value="parent.parentType" disabled>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="student-relative-info" v-for="(relative, indexRelative) in student.relatives" :key="`${index}_${indexRelative}`">
                                    <div class="row">
                                        <div class="col-md-8 d-flex justify-content-start">
                                        </div>
                                        <div class="col-md-4 d-flex justify-content-end">
                                            <button type="button" class="btn btn-default btn-circle btn-add" v-if="indexRelative == student.relatives.length - 1 && student.relatives.length < 6" @click="addRelative(student, index)">
                                                <i class="fas fa-plus"></i>
                                            </button>
                                            <button type="button" class="btn btn-default btn-circle btn-remove" v-if="indexRelative > 0" @click="removeRelative(student, index, indexRelative)">
                                                <i class="fas fa-minus"></i>
                                            </button>
                                        </div>
                                    </div> 
                                    <div class="form-row">
                                        <div class="col-md-6">
                                            <div class="form-group">                
                                                <label class="font-weight-bold" for="relativeName">Nom</label>
                                                <input class="form-control form-control-sm" type="text" :name="`student[${index}]relative[${indexRelative}]relativeName`" v-model="relative.relativeName">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="font-weight-bold" for="relativeType">Relació</label>
                                                <input class="form-control form-control-sm" type="text" :name="`student[${index}]relative[${indexRelative}]relativeType`" v-model="relative.relativeType">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr v-if="student.leaveAlone == false" />
                            <div class="student-health-info">
                                <h3>DADES MÈDIQUES</h3>
                                <div class="form-row">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label class="font-weight-bold" for="allergies">Pateix alguna al·lèrgia?</label>
                                            <select v-model="student.allergies" class="form-control form-control-sm" :name="`student[${index}]allergies`" @change="e => onAllergiesChange(index, e.target.value)">
                                                <option v-for="option in trueFalseOptions" :key="`${index}_${option.value}`" :value="option.value">
                                                    {{ option.text }}
                                                </option>
                                            </select>                                          
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="form-group">                    
                                            <label class="font-weight-bold" for="allergiesDescription">A que?</label>
                                            <input class="form-control form-control-sm" type="text" :name="`student[${index}]allergiesDescription`" v-model="student.allergiesDescription">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">                    
                                    <div class="col-md-4">
                                        <div class="form-group">                    
                                            <label class="font-weight-bold" for="typeDisease">Pateix alguna malaltia física o crònica?</label>
                                            <select class="form-control form-control-sm" :name="`student[${index}]typeDisease`" v-model="student.typeDisease" @change="e => onTypeDiseaseChange(index, e.target.value)">
                                                <option v-for="option in trueFalseOptions" :key="`${index}_${option.value}`" :value="option.value">
                                                    {{ option.text }}
                                                </option>
                                            </select>  
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="form-group">                    
                                            <label class="font-weight-bold" for="typeDiseaseDescription">Quina?</label>
                                            <input class="form-control form-control-sm" type="text" :name="`student[${index}]typeDiseaseDescription`" v-model="student.typeDiseaseDescription">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">                    
                                    <div class="col-md-4">
                                        <div class="form-group">                    
                                            <label class="font-weight-bold" for="vaccinated">Te totes le vacunes segons el calendari?</label>
                                            <select class="form-control form-control-sm" :name="`student[${index}]vaccinated`" v-model="student.vaccinated">
                                                <option v-for="option in trueFalseOptions" :key="`${index}_${option.value}`" :value="option.value">
                                                    {{ option.text }}
                                                </option>
                                            </select>  
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="form-group">                    
                                            <label class="font-weight-bold" for="medicalObservations">Altres observacions mèdiques</label>
                                            <input class="form-control form-control-sm" type="text" :name="`student[${index}]medicalObservations`" v-model="student.medicalObservations">
                                        </div>
                                    </div>
                                </div>
                                <!-- - -->
                                <div class="form-row">                    
                                    <div class="col-md-4">
                                        <div class="form-group">                    
                                            <label class="font-weight-bold" :for="`student[${index}]catsalut`">Afegir catsalut</label>
                                            <input class="form-control form-control-lg" :id="`student[${index}]catsalut`" type="file" :name="`student[${index}]catsalut`" accept="image/*" @change="e => student.catsalut = e.target.files[0]">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">                    
                                            <label class="font-weight-bold" :for="`student[${index}]vaccinationBook`">Afegir llibre de vacunacions</label>
                                            <input class="form-control form-control-lg" :id="`student[${index}]vaccinationBook`" type="file" :name="`student[${index}]vaccinationBook`" accept="image/*,.pdf" @change="e => student.vaccinationBook = e.target.files[0]">
                                        </div>
                                    </div>
                                </div>
                                <!-- - -->
                            </div>
                            <hr />
                            <div class="student-activities-selection week-data-title" :data-index="index" :key="categoryIndex" v-for="(category, categoryIndex) in student.getCategoriesPeriods()">
                                <div class="row" >
                                    <div class="col-md-12">
                                        <h3>{{ category.name }}</h3>
                                        <h5 v-if="category.description" >{{ category.description }}</h5>
                                        <p>SELECCIONA ELS PERÍODES DEL {{ category.name }} PER A L'ALUMNE:</p>
                                    </div>
                                </div>
                                <div class="form-row" >
                                    <div class="col-md-3" v-for="period in student.getPeriodsFromCategory(category.name)" :key="period.id" >
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" :name="`student[${index}]weekData`" type="checkbox" :id="`student[${index}]${period.id}`" :disabled="checkPeriodDisabled(student, period)" :value="`${category.name}_${period.start}_${period.end}`" v-model="student.selectedPeriods">
                                            <label class="form-check-label" :for="`student[${index}]${period.id}`">{{ period.title }}</label>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </div>
                        </div>
                        <br />
                        <div class="add-student-section">
                            <div class="row">
                                <div class="col-md-12 d-flex justify-content-end">
                                    <button type="button" class="btn btn-default btn-circle btn-add" v-if="index == students.length - 1" @click="addStudent()">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                    <button type="button" class="btn btn-default btn-circle btn-remove" v-if="index > 0" @click="removeStudent(student, index)">
                                        <i class="fas fa-minus"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="step step-3 cofiguration col-12" v-if="currentStep == 3">
                <div class="alert alert-info">
                    <strong>Tercer pas: </strong>MARQUEU L’ACTIVITAT DE CADA ALUMNE PER SETMANA INSCRITA. AFEGIU, SI CAL, L’ACOLLIDA I EL MENJADOR.
                </div>
                <div v-if="showFirstWeekWarning" class="alert alert-warning mt-3">
                    <p class="mb-2">
                        La setmana del 22/06/2026 al 26/06/2026 no hi haurà especialitats, només es farà un casal genèric pels nens i nenes de primària.
                    </p>
                    <button type="button" class="btn btn-primary btn-sm mr-2" @click="confirmFirstWeekWarning">
                        Continuar
                    </button>
                    <button type="button" class="btn btn-secondary btn-sm" @click="cancelFirstWeekWarning">
                        Cancel·lar
                    </button>
                </div>
                <br>
                <div class="students-selection-area">
                    <div class="student-selection" v-for="(student, studentIndex) in students" :key="studentIndex">
                        <div class="student-name"><h2>{{ student.name }}</h2></div>
                        <div class="weeks-selection-area">
                            <div class="week-selection">

                                    <div class="table-wrapper" v-for="(checkLine, checkLineIndex) in checkLines[studentIndex]" :key="checkLineIndex">
                                        <!-- 
                                        <div class="table-grid table-grid-col-4 table-grid-header" :class="checkLineIndex > 0 ? 'mobile' : 'desktop'"> 
                                        -->
                                        <div class="table-grid table-grid-header-responsive table-grid-header" :class="checkLineIndex > 0 ? 'mobile' : 'desktop'">
                                            <div class="item" scope="col">Període</div>
                                            <div class="item" scope="col">Casal</div>
                                            <div class="item" scope="col">Disponibilitat</div>
                                            <!--
                                            <div class="item" scope="col">Horari</div>
                                            -->
                                            <div class="item " scope="col">Horari</div>
                                        </div>
                                        <div class="table-grid table-grid-col-4 table-grid-rows">
                                            <div class="item" scope="row">{{ checkLine.getPeriodDescription() }}</div>
                                            <div class="item">                                        
                                                <select class="form-control form-control-sm" :name="`student[${studentIndex}]product[${checkLineIndex}]`" @change="evt => { checkLine.setProductById(evt.target.value); $forceUpdate(); }">
                                                    <option :value="null">Selecciona una opció</option>
                                                    <option v-for="product in checkLine.getProducts()" :key="product.id" :value="product.id" :selected="product.id === (checkLine.product && checkLine.product.id)">
                                                        {{ product.title }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="item"><span v-if="checkLine.period">{{ checkLine.period.stock === -1 ? "SENSE LÍMIT" : checkLine.period.stock }}</span></div>
                                            <!-- 
                                            <div class="item item-has-table table-grid-col-4">
                                            -->
                                            <div class="item item-has-table table-grid-horari-responsive">
                                                <div class="table-grid table-grid-item-horari-responsive" v-for="(value, prop) in checkLine.getAvaliableSchedules()" :key="prop">
                                                    <!--
                                                    <div class="item"><input class="form-check-input" type="checkbox" :id="`${studentIndex}inlineCheckbox-${prop}-${checkLineIndex}`" :value="value" v-model="checkLine.schedules" :disabled="value === scheduleValues.morning"></div>
                                                    -->
                                                    <div class="item item-right"><input class="form-check-input" type="checkbox" :id="`${studentIndex}inlineCheckbox-${prop}-${checkLineIndex}`" :value="value" v-model="checkLine.schedules" :disabled="value === scheduleValues.morning || value === scheduleValues.all"></div>
                                                    <!--
                                                    <div class="item"><label class="form-check-label" :for="`${studentIndex}inlineCheckbox-${prop}-${checkLineIndex}`">{{ value.capitalize() }}</label></div>
                                                    -->
                                                    <div class="item item-left"><label class="form-check-label" :for="`${studentIndex}inlineCheckbox-${prop}-${checkLineIndex}`">{{ value.capitalize() }}</label></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                            </div>
                        </div>
                    </div>
                    <br>
                </div>
            </section>
            
            <section class="step step-4 resume col-12" v-if="currentStep == 4">
                <div class="alert alert-info">
                    <strong>RESUM: </strong>Si us plau comprova que la selecció d'activitats és correcta.
                </div>
                <div class="alert alert-danger errors" style="display:none;"></div>                                
                <br>
                <div id="resume-area" class="students-resume-area">
                    <div class="variations-resume" v-if="total || reservationTotal">
                        <div class="student-variation-resume" v-for="(studentVariations, studentIndex) in variations" :key="studentIndex">
                            <div class="student-name" v-if="studentVariations.length"><h2>{{ students[studentIndex].name }}</h2></div>
                            <div class="weeks-resume-area" v-if="studentVariations.length">
                                <table class="table">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th scope="col" class="text-left">Casal</th>
                                            <th scope="col" class="text-left">Setmana</th>
                                            <th scope="col" class="text-center">Horari</th>
                                            <th scope="col" class="text-right">Tarifa</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="week-resume" v-for="(variation, variationIndex) in studentVariations" :key="studentIndex + '_variation_' + variationIndex">
                                            <th scope="row" class="text-left">{{ variation.product.title }}</th>
                                            <td class="text-left">{{ variation.periodsToString().capitalize() }}</td>
                                            <td class="text-center">{{ variation.schedule.capitalize() }}</td>
                                            <td class="text-right" v-if="variation.wooVariation">{{ variation.wooVariation.display_price.toFixed(2) }}€</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" class="text-left">Subtotal</th>
                                            <td></td>
                                            <td></td>
                                            <td class="text-right">{{ students[studentIndex].subtotal.toFixed(2) }}€</td>
                                        </tr>
                                        <tr v-if="students[studentIndex].discount">
                                            <th class="w-10">DESCOMPTE</th>
                                            <td class="w-70">{{ students[studentIndex].discount.title }}</td>
                                            <td class="w-10 text-center" >{{ students[studentIndex].discount.discount }} %</td>
                                            <td class="w-10 text-right" >- {{ students[studentIndex].calculateDiff() }}€</td>
                                        </tr>
                                        <!-- TODO: Contenido que ocultamos para hacer el casal de ESTIU -->
                                        <!-- <tr v-if="students[studentIndex].discount">
                                            <th class="w-10"></th>
                                            <th class="w-70 color-notice blue">EL DESCOMPTE NO S'APLICA A LA TARIFA MENJADOR</th>
                                            <th class="w-10"></th>
                                            <th class="w-10"></th>
                                        </tr> -->
                                        <tr v-for="(fixedCost, fixedCostsIndex) in students[studentIndex].fixedCosts" :key="studentIndex + '_fixedCosts_' + fixedCostsIndex">
                                            <th class="w-10">{{ fixedCost.post_title }}</th>
                                            <th class="w-70 color-notice blue">EL DESCOMPTE NO S'APLICA AL COST SORTIDA</th>
                                            <td class="w-10 text-center" >{{ parseFloat(fixedCost.price).toFixed(2) }}€</td>
                                            <td class="w-10 text-right" ></td>
                                        </tr>
                                        <tr>
                                            <th scope="row" class="text-left">Total {{ students[studentIndex].name }}</th>
                                            <th></th>
                                            <th></th>
                                            <th class="text-right">{{ students[studentIndex].total.toFixed(2) }}€</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                         
                        </div>
                        <hr />
                    </div>
                </div>
                
                <!-- Este apartado solo debe salir para casal estiu -->
                <div class="deposit-area" v-if="total && allowPartialDeposit && (casalId == 422 || casalId == 0)">
                    <div class="form-check" style="margin-bottom: 10px;">
                        <input type="checkbox" class="form-check-input" id="deposit" v-model="isPartialDeposit">
                        <label class="form-check-label" for="deposit">Marqueu aquesta opció per pagar només un {{partialDeposit}}% del total i la resta en el centre abans del 5 de juny.</label>
                    </div>
                </div>

                <!-- Este apartado solo debe salir para casal estiu -->
                <blockquote class="blockquote " style="border: none;" v-if="isPartialDeposit && (casalId == 422 || casalId == 0)">
                    <footer class="blockquote-footer">En el cas d’haver triat el pagament inicial del 25%, s’haurà de pagar la resta de l’import de la inscripció a la recepció del poliesportiu abans del dia 5 de juny. Podreu fer el pagament de l’import restant d’un cop o fraccionar-ho amb els terminis que vulgueu. Qualsevol inscripció no cobrada el dia abans d’aquesta data quedarà anul·lada.</footer>
                </blockquote>

                <div class="total-resumen-area" >
                    <table class="table w-50 p-3">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col" class="text-left">Total Reserva</th>
                                <th scope="col" class="text-right">{{ total }}€</th>
                            </tr>
                        </thead>
                    </table>

                    <!-- Este apartado solo debe salir para casal estiu -->
                    <table class="table w-50 p-3" v-if="isPartialDeposit && (casalId == 422 || casalId == 0)">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col" class="text-left">Total a pagar ara</th>
                                <th scope="col" class="text-right">{{ totalToPay }}€</th>
                            </tr>
                        </thead>
                    </table>

                    <table class="table w-50 p-3" v-if="isUserAdmin">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col" class="text-left">Afegir codi</th>
                                <th scope="col" class="text-right">
                                    <input type="text" class="form-control" id="addCodeSafa" placeholder="Codi" v-model="couponDiscountCode">
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>
                
                <div id="payment" class="total-resumen-area">
                    <table class="table w-50 p-3">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col" class="text-left">Mètodes de pagament </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td v-for="method in paymentMethods" :key="method.value">
                                    <input :id="`payment_method_${method.value}`" type="radio" class="input-radio" name="payment_method" :value="method.value" checked="checked" data-order_button_text="" v-model="paymentMethod">
                                    <label :for="`payment_method_${method.value}`">{{method.title}}</label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> 

                <div class="legal-area">
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <h3>Drets d'Imatge</h3>

                            <!-- Pregunta 1: WhatsApp -->
                            <p class="w-100 text-justify">El pare/mare del nen/-a inscrit ens autoritza els drets d’imatge si surt en fotografies de promoció i publicitat de la instal·lació i a la emissió d’imatges a través de les llistes de difusió del WhatsApp.</p>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="imageRightsWhatsapp" id="imageRightsWhatsappYes" value="1" v-model="imageRightsWhatsapp">
                                <label class="form-check-label" for="imageRightsWhatsappYes">Si autoritza</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="imageRightsWhatsapp" id="imageRightsWhatsappNo" value="0" v-model="imageRightsWhatsapp">
                                <label class="form-check-label" for="imageRightsWhatsappNo">No autoritza</label>
                            </div>

                            <!-- Pregunta 2: Promoció i publicitat -->
                            <p class="w-100 text-justify mt-3">El pare/mare ens autoritza els drets d'imatge si el nen/-a inscrit surt en fotografies de promoció i publicitat de la instal·lació.</p>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="imageRightsPromotion" id="imageRightsPromotionYes" value="1" v-model="imageRightsPromotion">
                                <label class="form-check-label" for="imageRightsPromotionYes">Si autoritza</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="imageRightsPromotion" id="imageRightsPromotionNo" value="0" v-model="imageRightsPromotion">
                                <label class="form-check-label" for="imageRightsPromotionNo">No autoritza</label>
                            </div>

                            <!-- Pregunta 3: Pàgina web i xarxes socials -->
                            <p class="w-100 text-justify mt-3">El pare/mare ens autoritza els drets d'imatge si el nen/-a inscrit surt en fotografies de la pàgina web i a la emissió d'imatges a través de les xarxes socials del Poliesportiu Safa Horta.</p>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="imageRightsSocialMedia" id="imageRightsSocialMediaYes" value="1" v-model="imageRightsSocialMedia">
                                <label class="form-check-label" for="imageRightsSocialMediaYes">Si autoritza</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="imageRightsSocialMedia" id="imageRightsSocialMediaNo" value="0" v-model="imageRightsSocialMedia">
                                <label class="form-check-label" for="imageRightsSocialMediaNo">No autoritza</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <h3>Autorització de responsabilitat</h3>
                            <!-- TODO: Contenido de casal Septembre -->
                            <p class="w-100 text-justify" v-if="casalId == 403">El pare/mare del nen/-a inscrit , l’autoritza a participar en el casal de setembre 2026 organitzat pel Poliesportiu Safa-Horta i a totes les sortides programades, manifesta que totes les dades facilitades són correctes, i fa extensiva aquesta autorització a les decisions medicoquirúrgiques que calgui adoptar, en cas d’extrema gravetat, sota la direcció facultativa pertinent.</p>
                            <!-- TODO: Contenido de casal estiu o per defecte-->
                            <p class="w-100 text-justify" v-if="casalId == 422 || casalId == 0">El pare/mare del nen/-a inscrit , l’autoritza a participar en el casal de juliol 2026 organitzat pel Poliesportiu Safa-Horta i a totes les sortides programades, manifesta que totes les dades facilitades són correctes, i fa extensiva aquesta autorització a les decisions medicoquirúrgiques que calgui adoptar, en cas d’extrema gravetat, sota la direcció facultativa pertinent.</p>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="legalAuthorization" id="legalAuthorizationYes" value="1" v-model="legalAuthorization">
                                <label class="form-check-label" for="legalAuthorizationYes">Si autoritza</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="legalAuthorization" id="legalAuthorizationNo" value="0" v-model="legalAuthorization">
                                <label class="form-check-label" for="legalAuthorizationNo">No autoritza</label>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-md-12 mb-3">
                            <h3>Requisits sanitaris</h3>
                            <p class="w-100 text-justify">EL PARE/MARE DECLARA QUE EL NEN/-A INSCRIT REUNEIX ELS REQUISITS SANITARIS EXIGITS EN EL CONTEX DE PANDEMIA ACTUAL I LES CIRCUMSTÀNCIES I RISC QUE COMPORTA.</p>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="healthRequirements" id="healthRequirementsYes" value="1" v-model="healthRequirements">
                                <label class="form-check-label" for="healthRequirementsYes">Si</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="healthRequirements" id="healthRequirementsNo" value="0" v-model="healthRequirements">
                                <label class="form-check-label" for="healthRequirementsNo">No</label>
                            </div>
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <h3>Política de privacitat</h3>
                            <p class="w-100 text-justify">Responsable dades personals: SPLASH SPORT S.L (NIF:B62045497), Carrer Torrent del Carmel 1-11, 08032 BARCELONA. Tel. 934201448. Email: <a href="mailto:info@poliesportiusafahorta.com">info@poliesportiusafahorta.com</a> En nom de l'empresa tractem la informació que ens facilita amb la finalitat de prestar el servei sol·licitat i realitzar la facturació d’aquest servei. Les dades proporcionades es conservaran mentre es mantingui la relació comercial o durant els anys necessaris per complir amb les obligacions legals. Les dades no es cediran a tercers excepte en els casos en què existeixi obligació legal. Vostè té dret a obtenir confirmació sobre si a SPLASH SPORT S.L estem tractant les seves dades personals i per tant té dret a accedir-hi, rectificar les dades inexactes o sol·licitar la seva supressió quan les dades ja no siguin necessàries. Així mateix sol·licitem la seva autorització per oferir-li productes i serveis relacionats amb els sol·licitats i fidelització com a client.</p>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" name="privacyPolicy" id="privacyPolicyYes" :value="1" v-model="privacyPolicy">
                                <label class="form-check-label" for="privacyPolicyYes">Accepto la política de privacitat de SPLASH SPORT S.L.</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" name="paymentPolicy" id="paymentPolicyYes" :value="1" v-model="paymentPolicy">
                                <!-- TODO: Contenido de casal de SETEMBRE -->
                                <label class="form-check-label" for="paymentPolicyYes" v-if="casalId == 403">Accepto la política de devolucions i cancel·lacions del Casal de setembre 2026</label>
                                <!-- TODO: Contenido de casal de ESTIU -->
                                <label class="form-check-label" for="paymentPolicyYes" v-if="casalId == 422 || casalId == 0">Accepto la política de devolucions i cancel·lacions del Casal d'Estiu 2026</label>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div class="mt-2 col-md-12"></div>
        </div>        
        <br><br>
        <div class="main-navigation">
            <div class="row justify-content-center">
                <div class="col-6 d-flex justify-content-start">
                    <button type="button" class="btn btn-primary" :disabled="currentStep <= 1" @click="goToStep(currentStep - 1)">Tornar</button>
                </div>
                <div class="col-6 d-flex justify-content-end">
                    <button type="button" class="btn btn-primary" v-scroll-to="'#safaApp'" :disabled="currentStep >= steps || this.loading" v-if="currentStep < steps" @click="goToStep(currentStep + 1)">Continuar</button>
                    <button type="button" class="btn btn-primary" v-if="currentStep === steps" @click="sendOrder" :disabled="isDisabled">Reservar</button>
                </div>
            </div>
        </div>
        <div class="loading-spinner" v-if="loading">
        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
</div>
</template>

<script>
import Order from '../entities/order.js';
import Student from '../entities/student.js';
import Variation from '../entities/variation.js';
import CheckLine from '../entities/checkLine.js';
import Period from '../entities/period.js';
import Promise from 'promise-polyfill';
import Product from '../entities/product';
import VueScrollTo from 'vue-scrollto';
import debounce from 'debounce';

let $ = window.jQuery;
let validate = window.validate;

export default {
    props: {
        discounts: Array,
        course: Array,
        partialDeposit: Number,
        paymentMethods: Array,
        permissionClient: Number,
        casalId: Number,
        isDefaultPartialDeposit: Boolean,
        allowPartialDeposit: Boolean
    },
    mounted(){
        this.addParent();
        this.addStudent();
    },
    data(){
        return {
            //Validación
            isValid: false,
            isStepValid: false,
            errors: {
                parents:[],
                students:[]
            },
            constraints: {},
            imageRightsWhatsapp: false,
            imageRightsPromotion: false,
            imageRightsSocialMedia: false,
            legalAuthorization: false,
            healthRequirements: false,
            privacyPolicy: false,
            paymentPolicy: false,
            showFirstWeekWarning: false,
            pendingStep: null,

            //Form
            steps: 4,
            currentStep: 1,
            loading: true,
            parents: [],
            students: [],
            variations: {},
            reservations: {},
            checkLines: {},
            scheduleValues: CheckLine.scheduleValues,
            trueFalseOptions: [
                { text: 'SELECCIONA', value: null },
                { text: 'SI', value: 1 },
                { text: 'NO', value: 0 }
            ],
            parentsOptions: [
                { text: 'SELECCIONA', value: null },
                { text: 'PARE', value: 'PARE' },
                { text: 'MARE', value: 'MARE' },
                { text: 'ALTRES', value: 'ALTRES' }
            ],
            
            //Prices
            deposit: this.allowPartialDeposit ? this.partialDeposit : 100,

            //isPartialDeposit: this.allowPartialDeposit ? this.isDefaultPartialDeposit : false,
            isPartialDeposit: (this.casalId == 422 || this.casalId == 0) ? (this.allowPartialDeposit ? this.isDefaultPartialDeposit : false) : false,
            paymentMethod: null,

            //User loggin 
            isUserAdmin: this.permissionClient,

            //Cupon code
            couponDiscountCode: ""
        };
    },
    components: {
    },
    methods: {
        // Helpers
        goToStep(step){
            if(step > this.currentStep){
                if(this.validateCurrentStep()){

                    //Mostrar aviso si la primera semana seleccionan futbol o dance.
                    if(this.currentStep === 3 && step === 4 && this.mustWarnFirstWeekCasal()){
                        this.pendingStep = step;
                        this.showFirstWeekWarning = true;
                        return;
                    }

                    let me = this;
                    this.currentStep = step;
                }
            }
            else{
                this.removeErrors();
                this.currentStep = step;
            }

            this.showData();
        },

        validateCurrentStep(){
            let $inputs = $(`.step-${this.currentStep}`).find("input, select");
            let names = [];

            $(".week-data-title").find("p").removeClass('is-invalid');
            $inputs.each(function(){
                let name = $(this).attr("name");
                if(name && !names.includes(name)){
                    names.push(name);
                }

                $(this).removeClass("is-invalid").parent().find(".messages").empty();
            });

            let errors = validate(validate.collectFormValues($("#safaApp").get(0)), this.constraints, {fullMessages: false});
            let message = "";
            let result = true;

            //TODO: Parche para modificaciones que han pedido
            //TODO: Control para que solo se haga este parche en abril
            if((new Date().getMonth() + 1) <= 4){
                if(this.currentStep == 2){
                    for(let i = 0; i < this.students.length; i++){
                        let student = this.students[i];

                        let studentPeriods = student.periods || [];
                        let studentSelectedPeriods = student.selectedPeriods || [];

                        if(!studentSelectedPeriods.length) continue;

                        let sortedStarts = studentPeriods.map(p => p.start).unique().sort((s1, s2) => Date.parse(s1) - Date.parse(s2));
                        let sortedStudentSelectedPeriods = studentSelectedPeriods.sort((p1, p2) => {
                            let composedCurrent = p1.split("_");
                            let composedNext = p2.split("_");

                            return Date.parse(composedCurrent[1]) - Date.parse(composedNext[1]);
                        });

                        let found = false;
                        for(let spi = 0; spi < sortedStudentSelectedPeriods.length; spi++){
                            if(spi == sortedStudentSelectedPeriods.length - 1) break;

                            let currentId = sortedStudentSelectedPeriods[spi] || "";
                            let nextId = sortedStudentSelectedPeriods[spi + 1] || "";

                            let composedCurrent = currentId.split("_");
                            let composedNext = nextId.split("_");

                            let currentIndex = sortedStarts.findIndex(s => s == composedCurrent[1]);
                            let nextIndex = sortedStarts.findIndex(s => s == composedNext[1]);

                            if(currentIndex == nextIndex - 1){
                                found = true;
                            }
                        }

                        if(!found){
                            alert(`Ha de seleccionar un mínim de 2 setmanes consecutives per a l'alumne ${student.name} ${student.firstName} ${student.lastName}`);
                            return false;
                        }
                    }
                }

                if(this.currentStep == 3){
                    for(let i = 0; i < this.students.length; i++){
                        let student = this.students[i];

                        let studentPeriods = student.periods || [];
                        let checkLines = this.checkLines[i] || [];
                        let emptyChecklines = checkLines.filter(ch => ch.product == null);

                        if(!checkLines.length || emptyChecklines.length) continue;

                        let sortedStarts = studentPeriods.map(p => p.start).unique().sort((s1, s2) => Date.parse(s1) - Date.parse(s2));
                        
                        let groups = {};

                        //Agrupamos
                        for(let chi = 0; chi < checkLines.length; chi++){
                            if(!groups[checkLines[chi].product.id]){
                                groups[checkLines[chi].product.id] = [];
                            }

                            groups[checkLines[chi].product.id].push(checkLines[chi].periodStart);
                        }

                        //Verificamos
                        let globalHasConsecutives = false;

                        for(let productId in groups){
                            let starts = groups[productId];

                            if(starts.length == 1){
                                continue;
                            }

                            let hasConsecutives = false;
                            for(let spi = 0; spi < starts.length; spi++){
                                if(spi == starts.length - 1) break;

                                let currentStart = starts[spi] || "";
                                let nextStart = starts[spi + 1] || "";

                                let currentIndex = sortedStarts.findIndex(s => (Date.parse(s)).getTime() == currentStart.getTime());
                                let nextIndex = sortedStarts.findIndex(s => (Date.parse(s)).getTime() == nextStart.getTime());

                                if(currentIndex == nextIndex - 1){
                                    hasConsecutives = true;
                                }
                            }

                            if(hasConsecutives) globalHasConsecutives = true;
                        }

                        if(!globalHasConsecutives){
                            alert(`Ha de seleccionar un mínim de 2 setmanes consecutives per a l'alumne ${student.name} ${student.firstName} ${student.lastName} amb el mateix casal.`);
                            return false;
                        }
                    }
                }
            }
            //------------------------------------------------------

            if(errors){
                for(let e in errors){
                    if(names.includes(e)){
                        let messages = errors[e] && (errors[e] instanceof Array ? errors[e].map(e => `<span>${e}</span>`).join("") : `<span>${errors[e]}</span>`);

                        if(e.indexOf('weekData') > 0){
                            let index = e.match(/(\d+)/)[0];
                            $(`.week-data-title[data-index="${index}"]`).find("p").addClass('is-invalid');
                        }
                        else{
                            let $input = $inputs.filter(`[name='${e}']`).eq(0);
                            $input.addClass("is-invalid");
                        }
                        
                        message += messages;
                        result = false;
                    }
                }
            }

            let $errors = $(".errors");
            
            if(message) $errors.show();
            else $errors.hide();
            
            $errors.html(message);
            return result;
        },

        mustWarnFirstWeekCasal(){
            const FUTBOL_PRODUCT_ID = 20738;
            const DANCE_PRODUCT_ID = 20739;

            for(let studentIndex = 0; studentIndex < this.students.length; studentIndex++){
                const checkLines = this.checkLines[studentIndex] || [];
                const student = this.students[studentIndex];

                const allPeriods = student.periods || [];

                if(!allPeriods.length){
                    continue;
                }

                //1. Primera semana REAL (global)
                const firstRealPeriod = allPeriods.reduce((min, current) => {
                    return new Date(current.start) < new Date(min.start) ? current : min;
                }, allPeriods[0]);

                const firstDate = new Date(firstRealPeriod.start);

                //2. Buscar si está seleccionada (comparando Y/M/D)
                const selectedFirstWeek = checkLines.find(cl => {
                    const d = cl.periodStart;

                    return (
                        d.getFullYear() === firstDate.getFullYear() &&
                        d.getMonth() === firstDate.getMonth() &&
                        d.getDate() === firstDate.getDate()
                    );
                });

                if(!selectedFirstWeek){
                    continue;
                }

                //3. Comprobar producto
                if(!selectedFirstWeek.product){
                    continue;
                }

                const productId = parseInt(selectedFirstWeek.product.id);

                if(productId === FUTBOL_PRODUCT_ID || productId === DANCE_PRODUCT_ID){
                    return true;
                }
            }

            return false;
        },

        confirmFirstWeekWarning(){
            this.showFirstWeekWarning = false;
            this.currentStep = this.pendingStep || 4;
            this.pendingStep = null;
            this.showData();
        },

        cancelFirstWeekWarning(){
            this.showFirstWeekWarning = false;
            this.pendingStep = null;
        },        

        removeErrors(){
            let $errors = $(".errors");
            $errors.hide();
        },

        isOdd(num) { 
            return num % 2;
        },

        // Students
        addStudent(){
            let student = new Student(this.discounts);
            this.students.push(student);

            //Constraints
            let index = this.students.length - 1;
            this.addRelative(student, index);

            let constraints = {
                "student[{index}]name": { presence: { message: `El camp "Nom" de l'alumne ${index + 1} és obligatori` } },
                "student[{index}]firstName": { presence: { message: `El camp "Primer Cognom" de l'alumne ${index + 1} és obligatori` } },
                "student[{index}]lastName": { presence: { message: `El camp "Segon Cognom" de l'alumne ${index + 1} és obligatori` } },
                "student[{index}]vat": { dni: { message: `El DNI de l'alumne ${index + 1} no és vàlid` } },
                "student[{index}]date": { presence: { message: `El camp "Data de Naixement" de l'alumne ${index + 1} és obligatori` } },
                "student[{index}]lastYear": { presence: { message: `El camp "Va assistir l'any anterior" de l'alumne ${index + 1} és obligatori` } },
                "student[{index}]school": { presence: { message: `El camp "Escola" de l'alumne ${index + 1} és obligatori` } },
                "student[{index}]schoolCourse": { presence: { message: `El camp "Curs Escola" de l'alumne ${index + 1} és obligatori` } },
                "student[{index}]leaveAlone": { presence: { message: `El camp "Pot marxar sol/a" de l'alumne ${index + 1} és obligatori` } },
                "student[{index}]allergies": { presence: { message: `El camp "Al·lèrgies" de l'alumne ${index + 1} és obligatori` } },
                "student[{index}]typeDisease": { presence: { message: `El camp "Malaltia física o crònica?" de l'alumne ${index + 1} és obligatori` } },
                "student[{index}]vaccinated": { presence: { message: `El camp "Te totes le vacunes segons el calendari?" de l'alumne ${index + 1} és obligatori` } },
                "student[{index}]weekData": { presence: { message: `Has de seleccionar una setmana en algun dels casals per a l'alumne ${index + 1} és obligatori` } },
                "student[{index}]catsalut": { presence: { message: `Has de seleccionar un fitxer de Catsalut para l'alumne ${index + 1} és obligatori` } },
                "student[{index}]vaccinationBook": { presence: { message: `Has de seleccionar un fitxer de llibre de vacunacions para l'alumne ${index + 1} és obligatori` } }
            };

            for(let i in constraints){
                this.constraints[i.replace("{index}", index)] = constraints[i];
            }

            if(index > 0) {
                setTimeout(function(){
                    VueScrollTo.scrollTo('#student-'+ index);
                }, 100);
            }
        },

        removeStudent(student, index){
            if(index >= 0 && index < this.students.length){
                this.students.splice(index, 1);

                for(let i in this.constraints){
                    if(i.indexOf(`student[${index}]`) === 0){
                        delete this.constraints[i];
                    }
                }
            }

            if(index > 0) {
                setTimeout(function(){
                    VueScrollTo.scrollTo('#student-'+ (index - 1));
                }, 100);
            }

            this.removeErrors();
        },

        makeStudent(){
            for (let index = 0; index < this.students.length; index++) {
                if(this.isOdd(index)) {            
                    this.students[index].allergies = 1;
                    this.students[index].allergiesDescription = "PLATANERO";
                    this.students[index].date = "2020-01-01";
                    this.students[index].firstName = "GONZALEZ";
                    this.students[index].lastName = "AMANCIO";
                    this.students[index].lastYear = 1;
                    this.students[index].leaveAlone = 1;
                    this.students[index].local = 0;
                    this.students[index].school = 'SANT JORDI';
                    this.students[index].medicalObservations = "GAFAS";
                    this.students[index].name = "JAUME";
                    this.students[index].schoolCourse = "P3";
                    this.students[index].typeDisease = 1;
                    this.students[index].typeDiseaseDescription = "ASMÁTICO";
                    this.students[index].vaccinated = 1;
                    this.students[index].vat = "43554514N"; 
                } else {
                    this.students[index].allergies = 1;
                    this.students[index].allergiesDescription = "PLATANERO";
                    this.students[index].date = "2020-01-01";
                    this.students[index].firstName = "TERRA";
                    this.students[index].lastName = "LUNA";
                    this.students[index].lastYear = 1;
                    this.students[index].leaveAlone = 1;
                    this.students[index].local = 0;
                    this.students[index].school = 'SANT JORDI';
                    this.students[index].medicalObservations = "GAFAS";
                    this.students[index].name = "MARTA";
                    this.students[index].schoolCourse = "1EP";
                    this.students[index].typeDisease = 1;
                    this.students[index].typeDiseaseDescription = "ASMÁTICO";
                    this.students[index].vaccinated = 1;
                    this.students[index].vat = "35103709M"; 
                }
            }
        },

        showData(){
            // window.console.log("parents", this.parents);
            // window.console.log("students", this.students);
            // window.console.log("variations", this.variations);
            // window.console.log("Reservations", this.reservations);
        },

        // Parents
        addParent(){
            let parent = {
                parentName: null,
                parentFirstName: null,
                parentLastName: null,
                parentVat: null,
                parentPhone1: null,
                parentPhone2: null,
                parentEmail: null,
                parentType: null,
                parentAddress: null,
                parentAddressNumber: null,
                parentAddressFloor: null,
                parentAddressDoor: null,
                parentAddressZip: null,
                parentAddressCity: null,                
            };

            this.parents.push(parent);

            //Constraints
            let index = this.parents.length - 1;
            let constraints = {
                "parent[{index}]parentName": { presence: { message: `El camp "Nom" del Familiar ${index + 1} és obligatori` } },
                "parent[{index}]parentFirstName": { presence: { message: `El camp "Primer Cognom" del Familiar ${index + 1} és obligatori` } },
                "parent[{index}]parentLastName": { presence: { message: `El camp "Segon Cognom" del Familiar ${index + 1} és obligatori` } },
                "parent[{index}]parentVat": { presence: { message: `El camp "DNI" del Familiar ${index + 1} és obligatori` }, dni: { message: `El camp DNI del Familiar ${index + 1} no és vàlid` } },
                "parent[{index}]parentPhone1": { presence: { message: `El camp "Telèfon 1" del Familiar ${index + 1} és obligatori` } },
                "parent[{index}]parentPhone2": { presence: { message: `El camp "Telèfon 2" del Familiar ${index + 1} és obligatori` } },
                "parent[{index}]parentEmail": { presence: { message: `El camp "Email" del Familiar ${index + 1} és obligatori` }, email: { message: `El camp "Email" del Familiar ${index + 1} no és vàlid` } },
                "parent[{index}]parentType": { presence: { message: `El camp "Relació" del Familiar ${index + 1} és obligatori` } },
                "parent[{index}]parentAddress": { presence: { message: `El camp "Adreça" del Familiar ${index + 1} és obligatori` } },
                "parent[{index}]parentAddressNumber": { presence: { message: `El camp "Nº" del Familiar ${index + 1} és obligatori` } },
                "parent[{index}]parentAddressZip": { presence: { message: `El camp "Codi Postal" del Familiar ${index + 1} és obligatori` } },
                "parent[{index}]parentAddressCity": { presence: { message: `El camp "Població" del Familiar ${index + 1} és obligatori` } }
            };

            for(let i in constraints){
                this.constraints[i.replace("{index}", index)] = constraints[i];
            }

            if(index > 0) {
                setTimeout(function(){
                    VueScrollTo.scrollTo('#parent-'+ index);
                }, 100);
            }            
        },

        removeParent(parent, indexParent){
            if(indexParent >= 0 && indexParent < this.parents.length){
                this.parents.splice(indexParent, 1);

                for(let i in this.constraints){
                    if(i.indexOf(`parent[${indexParent}]`) === 0){
                        delete this.constraints[i];
                    }
                }
            }

            if(indexParent > 0) {
                setTimeout(function(){
                    VueScrollTo.scrollTo('#parent-'+ (indexParent - 1));
                }, 100);
            }
            
            this.removeErrors();
        },

        makeParent(){
            for (let index = 0; index < this.parents.length; index++) {
                if(this.isOdd(index)) {
                    this.parents[index].parentAddress = "MARAGALL";
                    this.parents[index].parentAddressCity = "Barcelona";
                    this.parents[index].parentAddressDoor = "2";
                    this.parents[index].parentAddressFloor = "1";
                    this.parents[index].parentAddressNumber = "111";
                    this.parents[index].parentAddressZip = "08041";
                    this.parents[index].parentEmail = "USUARIO@USUARIO.COM";
                    this.parents[index].parentFirstName = "SOL";
                    this.parents[index].parentLastName = "MONTE";
                    this.parents[index].parentName = "LAURA";
                    this.parents[index].parentPhone1 = "616446954";
                    this.parents[index].parentPhone2 = "638668176";
                    this.parents[index].parentType = "MARE";
                    this.parents[index].parentVat = "47714265Y";
                } else {
                    this.parents[index].parentAddress = "MARAGALL";
                    this.parents[index].parentAddressCity = "Barcelona";
                    this.parents[index].parentAddressDoor = "2";
                    this.parents[index].parentAddressFloor = "1";
                    this.parents[index].parentAddressNumber = "111";
                    this.parents[index].parentAddressZip = "08041";
                    this.parents[index].parentEmail = "USUARIO@USUARIO.COM";
                    this.parents[index].parentFirstName = "GONZÁLEZ";
                    this.parents[index].parentLastName = "PRIETO";
                    this.parents[index].parentName = "JAVIER";
                    this.parents[index].parentPhone1 = "616446954";
                    this.parents[index].parentPhone2 = "628668176";
                    this.parents[index].parentType = "PARE";
                    this.parents[index].parentVat = "43536924V";                    
                }
            }
        },

        // Relatives
        addRelative(student, studentIndex){
            student.addRelative();

            //Constraints
            let index = student.relatives.length - 1;
            let constraints = {
                "student[{index}]relative[{indexRelative}]relativeName": { },//presence: { message: `El camp "Nom" del Autoritzat ${(index + 1) * (studentIndex + 1)} és obligatori` } },
                "student[{index}]relative[{indexRelative}]relativeType": { }//presence: { message: `El camp "Relació" del Autoritzat ${(index + 1) * (studentIndex + 1)} és obligatori` } }
            };

            for(let i in constraints){
                this.constraints[i.replace("{index}", studentIndex).replace('{indexRelative}', index)] = constraints[i];
            }
        },

        removeRelative(student, studentIndex, relativeIndex){
            if(relativeIndex >= 0 && relativeIndex < student.relatives.length){
                student.removeRelative(student.relatives[relativeIndex]);

                for(let i in this.constraints){
                    if(i.indexOf(`student[${studentIndex}]relative[${relativeIndex}]`) === 0){
                        delete this.constraints[i];
                    }
                }
            }
        },

        onTypeDiseaseChange(studentIndex, value){
            if(value === '1'){
                this.constraints[`student[${studentIndex}]typeDiseaseDescription`] = { presence: true };
            }
            else{
                this.constraints[`student[${studentIndex}]typeDiseaseDescription`] = {};
                this.students[studentIndex].typeDiseaseDescription = null;
                this.$forceUpdate();
            }
        },

        onAllergiesChange(studentIndex, value){
            if(value === '1'){
                this.constraints[`student[${studentIndex}]allergiesDescription`] = { presence: true };
            }
            else{
                this.constraints[`student[${studentIndex}]allergiesDescription`] = {};
                this.students[studentIndex].allergiesDescription = null;
                this.$forceUpdate();                
            }
        },

        onLocalChange(studentIndex, value){
            let student = this.students[studentIndex];

            if(value === '0'){
                if(student.lastYear){
                    this.constraints[`student[${studentIndex}]school`] = { presence: true };
                }
                else{
                    this.constraints[`student[${studentIndex}]school`] = {};
                }
            }
            else{
                this.constraints[`student[${studentIndex}]school`] = {};
                student.school = null;
            }
        },

        async onSchoolCourseChange(studentIndex, value){
            let student = this.students[studentIndex];
            let courses = this.course.filter(c => !!c.value); //Excluimos el null
            student.checkDateAndCourse(courses);

            this.loading = true;
            //Revisar aqui
            let periods = await this.getPeriodsByCourseID(student.schoolCourse);
            student.setPeriods(periods);

            this.loading = false;

            this.$forceUpdate();
        },

        checkPeriodDisabled(student, period){
            let categoryName = period.category.name;
            let start = Date.parse(period.start);
            let end = Date.parse(period.end);
        
            //Comprovem stock
            if(period.stock == 0){
                return true;
            }

            for(let selectedPeriodId of student.selectedPeriods){
                let _composed = selectedPeriodId.split("_");
                let _categoryName = _composed[0];
                let _start = Date.parse(_composed[1]);
                let _end = Date.parse(_composed[2]);

                if(_categoryName == categoryName && _start.getTime() == start.getTime() && _end.getTime() == _end.getTime()){
                    continue;
                }

                if(_start >= start && _start <= end){
                    return true;
                }
                else if(_end >= start && _end <= end){
                    return true;
                }
                else if(_start <= start && _end >= end){
                    return true;
                }
                else if(_start >= start && _end <= end){
                    return true;
                }
            }

            return false;
        },

        showParents(){
            //window.console.log(this.parents);
        },        
        
        //Ajax
        getPeriodsByCourseID(id){
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: "/wp-admin/admin-ajax.php",
                    type: 'POST',
                    data: {
                        action:'safa_get_periods_by_courseID',
                        courseID: id,
                        casalId: this.casalId
                    },
                    success:function(response){
                        if(response instanceof Array){
                            response = response.map(p => new Period(p.ID, p.post_title, p.dateStart, p.dateEnd, p.product, p.terms[0], p.course, p.stock, p.reservations));
                        }
                        else{
                            response = new Period(response.ID, response.post_title, response.dateStart, response.dateEnd, response.product, response.terms[0], response.course, response.stock, response.reservations);
                        }
                        console.log(response);
                        resolve(response);
                    },
                    error: function(error){
                        reject(error);
                    }
                });
            });
        },

        //Orders
        async sendOrder(){
            if(!this.validateCurrentStep()){
                VueScrollTo.scrollTo('#safaApp');

                return false;
            }

            let order = new Order(
                this.parents, 
                this.deposit, 
                this.total, 
                this.totalToPay, 
                this.reservationTotal, 
                this.imageRightsWhatsapp,
                this.imageRightsPromotion,
                this.imageRightsSocialMedia, 
                this.legalAuthorization, 
                this.healthRequirements, 
                this.paymentMethod,
                this.isPartialDeposit,
                this.couponDiscountCode
            );
            
            for(let i in this.students){
                let student = this.students[i];
                order.addStudent(student);
            }

            this.loading = true;

            try{
                let response = await order.send();
                let url = response && response.url;

                if(url){
                    // this.loading = false;
                    window.location.href = url;
                }
                else{
                    this.loading = false;
                    alert(response);
                }

                console.log(response, url);
            }
            catch(e){
                console.log("ERROR: ", e);
                this.loading = false;
            }
        },

        //CheckLines
        calculateCheckLinesFromStudent(studentIndex){
            let student = this.students[studentIndex];
            let checkLines = [];

            //CASALS
            if(student.selectedPeriods && student.selectedPeriods.length){
                for(let periodId of student.selectedPeriods){
                    let composed = periodId.split("_");
                    let categoryName = composed[0];
                    let start = composed[1];
                    let end = composed[2];

                    checkLines.push(new CheckLine(start, end, student.periods.filter(p => p.category.name == categoryName)));
                }
            }

            return checkLines.sort((checkLine1, checkLine2) => {
                return checkLine1.periodStart - checkLine2.periodStart;
            });
        },

        //Variations
        calculateVariationsAndReservationsFromStudent(studentIndex){
            let student = this.students[studentIndex];
            let checkLines = this.checkLines[studentIndex];
            return CheckLine.extractVariationsAndReservations(checkLines);
        }
    },
    computed: {
        total(){
            let result = 0;

            for(let student of this.students){
                result += student.total;
            }

            if(result){
                return result.toFixed(2);
            }
            
            return result;
        },

        reservationTotal(){
            let result = 0;

            for(let student of this.students){
                result += student.reservationSubtotal;
            }
            
            if(result){
                return result.toFixed(2);
            }
            
            return result;
        },

        totalToPay(){
            let finalDiscount = 100 - this.deposit;
            return (this.total - (this.total * finalDiscount / 100)).toFixed(2);
        },

        isDisabled: function (){
            if (            
                this.imageRightsWhatsapp
                && this.imageRightsPromotion
                && this.imageRightsSocialMedia
                && this.legalAuthorization
                && this.privacyPolicy
                && this.paymentPolicy
                && this.paymentMethod
            ){
                return false;
            }
            
            return true;
        }
    },
    watch: {
        isPartialDeposit: {
            immediate: true,
            handler(value){
                if(value && this.allowPartialDeposit){
                    this.deposit = this.partialDeposit;
                }
                else{
                    this.deposit = 100;
                }
            }
        },

        deposit(value){
            this.loading = true;

            for(let student of this.students){
                student.calculateDiscount(this.students.length, value === 100);
                student.calculateTotal();
            }

            this.loading = false;
            this.$forceUpdate();
        },

        currentStep:{
            immediate: true,
            handler(newVal, oldVal){
                switch(newVal){
                    case 3:
                        if(oldVal > newVal){
                            return;
                        }

                        //Weeks
                        this.checkLines = {};
                        this.loading = true;

                        for(let student of this.students){
                            let studentIndex = this.students.indexOf(student);
                            this.checkLines[studentIndex] = this.calculateCheckLinesFromStudent(studentIndex);
                            
                            //Borrem anteriors constraints
                            for(let i in this.constraints){
                                if(i.indexOf(`student[${studentIndex}]`) === 0 && i.indexOf("product") > 0){
                                    delete this.constraints[i];
                                }
                            }

                            //Posem noves constraints
                            for(let i in this.checkLines[studentIndex]){
                                this.constraints[`student[${studentIndex}]product[${i}]`] = {presence: true};
                            }
                        }

                        this.loading = false;
                        
                        break;
                    case 4:
                        if(oldVal > newVal){
                            return;
                        }

                        //Variaciones
                        this.variations = {};
                        this.loading = true;

                        for(let student of this.students){
                            let studentIndex = this.students.indexOf(student);
                            let result = this.calculateVariationsAndReservationsFromStudent(studentIndex);
                            this.$set(this.variations, studentIndex, result.variations);
                            this.$set(this.reservations, studentIndex, result.reservations);

                            student.setVariations(result.variations);
                            student.setReservations(result.reservations);

                            //TODO: Poner handler de errores
                            
                            if(student.reservations && student.reservations.length){
                                student.calculateReservationSubtotal();
                            }
                            else{
                                student.reservationSubtotal = 0;
                            }

                            if(student.variations && student.variations.length){
                                student.calculateSubtotal();
                                student.calculateDiscount(this.students.length, this.deposit === 100);
                                student.calculateTotal();
                            }
                            else{
                                student.subtotal = 0;
                                student.total = 0;
                                student.discount = null;
                            }
                        }

                        this.constraints["imageRightsWhatsapp"] = { presence: { message: `HAS DE RESPONDRE LA PREGUNTA SOBRE DRETS D'IMATGE (WHATSAPP).` } };
                        this.constraints["imageRightsPromotion"] = { presence: { message: `HAS DE RESPONDRE LA PREGUNTA SOBRE DRETS D'IMATGE (PROMOCIÓ I PUBLICITAT).` } };
                        this.constraints["imageRightsSocialMedia"] = { presence: { message: `HAS DE RESPONDRE LA PREGUNTA SOBRE DRETS D'IMATGE (XARXES SOCIALS).` } };
                        this.constraints["legalAuthorization"] = { presence: { message: `HAS D'AUTORITZAR L'OPCIÓ DE RESPONSABILITAT.` } };
                        this.constraints["healthRequirements"] = { presence: { message: `HAS D'AUTORITZAR L'OPCIÓ DE REQUISITS SANITARIS.` } };

                        this.loading = false;
                        
                        break;
                    default:
                        this.loading = false;
                }
            }
        }
    }
};
</script>